import { getStaticOptions, localStorageTest } from "../../utils";
const LOCAL_STORAGE_KEY_QUEUE_NOTIFY_WORKER_PREFIX = "real-queue-notify-worker-";
/**
 * Notify worker tab to do something.
 */ function notifyWorkerTab(data) {
    if (localStorageTest()) {
        const lsKey = `${LOCAL_STORAGE_KEY_QUEUE_NOTIFY_WORKER_PREFIX}${getStaticOptions().localStorageSuffix}-${new Date().getTime()}`;
        localStorage.setItem(lsKey, JSON.stringify(data));
        return true;
    }
    return false;
}
export { notifyWorkerTab, LOCAL_STORAGE_KEY_QUEUE_NOTIFY_WORKER_PREFIX };
